import { render } from "./EntryBlock.vue?vue&type=template&id=1da2bb31"
import script from "./EntryBlock.vue?vue&type=script&lang=js"
export * from "./EntryBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__